const CHUNK_ERROR_MESSAGE =
  /Failed to load chunk|Loading (CSS )?chunk|dynamically imported module/i;

const RELOAD_STAMP_KEY = 'chunk-error-reloaded-at';

// Long enough that a reload which keeps failing cannot loop, short enough that the
// next deploy seen by a long-lived tab (kiosk, installed app) recovers on its own.
const RELOAD_WINDOW_MS = 5 * 60 * 1000;

export function isChunkLoadError(e: unknown): boolean {
  if (!e || typeof e !== 'object') return false;
  const { name, message } = e as { name?: unknown; message?: unknown };
  if (name === 'ChunkLoadError') return true;
  return typeof message === 'string' && CHUNK_ERROR_MESSAGE.test(message);
}

/**
 * Reloads the document at most once per window per tab. Returns true when a reload was
 * triggered. The last reload time is kept in sessionStorage; a stamp less than one window
 * away, before or after now (clock moved back), skips the reload, so a stamp in the future
 * blocks it for at most one window. If the stamp cannot be written and
 * read back, or storage throws, no reload happens: without a stored stamp nothing would
 * stop the next load from reloading again.
 */
export function reloadOnceForChunkError(): boolean {
  const now = Date.now();
  const stamp = String(now);
  try {
    const storage = window.sessionStorage;
    const last = Number(storage.getItem(RELOAD_STAMP_KEY));
    if (Number.isFinite(last) && last > 0 && Math.abs(now - last) < RELOAD_WINDOW_MS) return false;
    storage.setItem(RELOAD_STAMP_KEY, stamp);
    if (storage.getItem(RELOAD_STAMP_KEY) !== stamp) return false;
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}
